import { Paper } from '@mui/material'
import { Container } from '@mui/system'
import { PatientDocuments as PatientDocumentsFeature } from '@/features/patient/patient-documents'
import ContentHeader from '../components/ContentHeader'
import { useTranslation } from 'react-i18next'

type PatientDocumentsProps = {
  patientId: string
}

export default function PatientDocuments(props: PatientDocumentsProps) {
  let { patientId } = props
  const { t } = useTranslation()
  return (
    <Container maxWidth="md" sx={{ px: '0 !important', pt: '20px', pb: '20px' }}>
      <Paper>
        <ContentHeader sx={{ p: '20px 16px' }} title={t('page.liveConsultation.patientDocument.title')} />
        <div
          style={{
            margin: '0px 16px',
          }}
        >
          <PatientDocumentsFeature patientId={patientId} />
        </div>
      </Paper>
    </Container>
  )
}
